import NavCtrl from './NavCtrl';

export default angular.module('App.Navigation', [])
    .controller('NavCtrl', NavCtrl);


// WEBPACK FOOTER //
// ./src/app/modules/navigation/index.js